import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Ce service permet de gérer l'ouverture ou la fermeture des modals
 * depuis un appel externe (réponse http, ...)
 */

@Injectable()
export class CoreModalService {
  close$ = new Subject<boolean>();
  open$ = new Subject<string>();

  /**
   * Ferme toutes les modals
   */
  closeAllModal() {
    this.close$.next(true);
  }

  /**
   * Ouvre une modal en prenant en paramètre la classe de ladite modal
   * @param modalClass : la classe de la modal à ouvrir
   */
  open(modalClass = '') {
    this.open$.next(modalClass);
  }
}
